/** Shared metadata header lines for note PDF export (UI + server). */

export function formatNoteMetadataSnapshotLines(meta: Record<string, unknown>): string[] {
  const lines: string[] = ['Session metadata:'];
  if (meta.start) lines.push(`  Start: ${String(meta.start)}`);
  if (meta.end) lines.push(`  End: ${String(meta.end)}`);
  if (meta.durationMinutes != null) lines.push(`  Duration (min): ${String(meta.durationMinutes)}`);
  if (meta.attendance) lines.push(`  Attendance: ${String(meta.attendance)}`);
  if (meta.modality) lines.push(`  Modality: ${String(meta.modality)}`);

  const locations = Array.isArray(meta.locations)
    ? meta.locations.map(String).filter(Boolean)
    : meta.location
      ? [String(meta.location)]
      : [];
  if (locations.length > 0) lines.push(`  Location(s): ${locations.join('; ')}`);

  const providers = Array.isArray(meta.renderingProviders)
    ? meta.renderingProviders
        .map((p) => {
          if (p && typeof p === 'object' && 'display' in p) {
            return String((p as { display?: string }).display ?? '').trim();
          }
          return '';
        })
        .filter(Boolean)
    : [];
  if (providers.length > 0) lines.push(`  Rendering provider(s): ${providers.join(', ')}`);

  const episode = meta.episodeOfCare;
  if (episode && typeof episode === 'object') {
    const display =
      'display' in episode && episode.display
        ? String(episode.display)
        : 'reference' in episode && episode.reference
          ? String(episode.reference)
          : '';
    if (display) lines.push(`  Episode of care: ${display}`);
  }
  if (meta.units != null) lines.push(`  Units: ${String(meta.units)}`);
  return lines;
}
